<template>
  <v-card>
    <v-toolbar dense flat>
      <v-btn icon style="position:absolute;top:2px;left:10px;" @click="$router.go(-1)">
        <v-icon>arrow_back</v-icon>
      </v-btn>
      <v-spacer/>
      <h2>General Information</h2>
      <v-spacer/>
    </v-toolbar>

    <v-card-text>
      <v-layout row wrap>
        <v-flex xs12 md6>
          <v-card class="pb-2 my-3 mr-2 min-height">
            <v-toolbar dense flat>
              <v-spacer/>
              <h2 class="text-xs-center">Rider Profiles</h2>
              <v-spacer/>
            </v-toolbar>
            <v-layout row justify-center class="pt-3">
              <v-flex xs6 class="text-xs-center">
                <a
                  :href="rider.user_info_im.ri_profile_img"
                  target="_blank"
                  style="text-decoration:none;"
                >
                  <v-img
                    v-if="rider.user_info_im.ri_profile_img"
                    :src="rider.user_info_im.ri_profile_img"
                    aspect-ratio="1"
                    contain
                    height="200"
                  ></v-img>
                  <v-img
                    v-else
                    src="https://www.freeiconspng.com/uploads/no-image-icon-6.png"
                    aspect-ratio="1"
                    contain
                    height="200"
                  ></v-img>
                </a>
              </v-flex>
              <v-flex xs6 class="px-2">
                <p>
                  <strong>Name :</strong>
                  {{ rider.users.users_name }}
                </p>
                <p>
                  <strong>Email :</strong>
                  {{ rider.users.users_email }}
                </p>
                <p>
                  <strong>Telephone :</strong>
                  {{ rider.users.users_phone }}
                </p>
                <p>
                  <strong>Status :</strong>
                  {{ rider.users.user_status == 1 ? 'Active'
                  : rider.users.user_status == 2 ? 'Pending'
                  : rider.users.user_status == 3 ? 'Inactive' : null }}
                </p>
                <strong>Referral code :</strong>
                {{ rider.users.users_phone }}
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
        <v-flex xs12 md6>
          <v-card class="pb-2 my-3 ml-2 min-height">
            <v-toolbar dense flat>
              <v-spacer/>
              <h2 class="text-xs-center">Vehicle</h2>
              <v-spacer/>
            </v-toolbar>
            <v-layout row justify-center class="pt-3">
              <v-flex xs6 class="text-xs-center">
                <a
                  :href="rider.user_info_im.ri_plate_number_img"
                  target="_blank"
                  style="text-decoration:none;"
                >
                  <v-img
                    v-if="rider.user_info_im.ri_plate_number_img"
                    :src="rider.user_info_im.ri_plate_number_img"
                    aspect-ratio="1"
                    contain
                    height="200"
                  />
                  <v-img
                    v-else
                    src="https://www.freeiconspng.com/uploads/no-image-icon-6.png"
                    aspect-ratio="1"
                    contain
                    height="200"
                  />
                </a>
              </v-flex>
              <v-flex xs6 class="px-2">
                <p>
                  <strong>Name :</strong>
                  {{ rider.user_info.ri_vehicle_model == 1 ? 'รถจักรยานยนต์'
                  : rider.user_info.ri_vehicle_model == 2 ? 'รถยนต์ 4 ประตู'
                  : rider.user_info.ri_vehicle_model == 3 ? 'รถกระบะ/รถบรรทุก' : null }}
                </p>
                <!-- <p>
                  <strong>Box :</strong>
                  <span v-if="rider.user_info.ri_motor_box">มีกล่องบรรจุ</span>
                  <span v-else>ไม่มีกล่องบรรจุ</span>
                </p>-->
                <p>
                  <strong>Brand :</strong>
                  {{ rider.user_info.ri_vehicle_brand }}
                </p>
                <p>
                  <strong>Model :</strong>
                  {{ rider.user_info.ri_vehicle_model_name }}
                </p>
                <p>
                  <strong>Years :</strong>
                  {{ rider.user_info.ri_vehicle_model_year }}
                </p>
                <p>
                  <strong>Number :</strong>
                  {{ rider.user_info.ri_plate_number }}
                </p>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
      <div>
        <!-- <v-divider/> -->
        <!-- <h2 class="text-xs-center">Other</h2> -->
        <v-layout row wrap class="pt-3">
          <v-flex lg3 md4 sm6 xs12 class="text-xs-center pt-2">
            <div>
              Personal ID :
              <br>
              {{ rider.user_info.ri_id_card_no }}
            </div>
            <a
              :href="rider.user_info_im.ri_id_card_img"
              target="_blank"
              style="text-decoration:none;"
            >
              <v-img
                v-if="rider.user_info_im.ri_id_card_img"
                :src="rider.user_info_im.ri_id_card_img"
                aspect-ratio="1"
                contain
                height="200"
              />
              <v-img
                v-else
                src="https://www.freeiconspng.com/uploads/no-image-icon-6.png"
                aspect-ratio="1"
                contain
                height="200"
              />
            </a>
          </v-flex>
          <v-flex lg3 md4 sm6 xs12 class="text-xs-center pt-2">
            <div>
              Driving License No :
              <br>
              {{ rider.user_info.ri_drivg_licent_no }}
            </div>
            <a
              :href="rider.user_info_im.ri_driving_license_front_img"
              target="_blank"
              style="text-decoration:none;"
            >
              <v-img
                v-if="rider.user_info_im.ri_driving_license_front_img"
                :src="rider.user_info_im.ri_driving_license_front_img"
                aspect-ratio="1"
                contain
                height="200"
              />
              <v-img
                v-else
                src="https://www.freeiconspng.com/uploads/no-image-icon-6.png"
                aspect-ratio="1"
                contain
                height="200"
              />
            </a>
          </v-flex>
          <v-flex lg3 md4 sm6 xs12 class="text-xs-center pt-2">
            <div>
              Vehicle registration book :
              <br>
              {{rider.user_info.ri_registerbook}}
            </div>
            <a
              :href="rider.user_info_im.ri_registerbook_img"
              target="_blank"
              style="text-decoration:none;"
            >
              <v-img
                v-if="rider.user_info_im.ri_registerbook_img"
                :src="rider.user_info_im.ri_registerbook_img"
                aspect-ratio="1"
                contain
                height="200"
              />
              <v-img
                v-else
                src="https://www.freeiconspng.com/uploads/no-image-icon-6.png"
                aspect-ratio="1"
                contain
                height="200"
              />
            </a>
          </v-flex>
          <v-flex lg3 md4 sm6 xs12 class="text-xs-center pt-2">
            <div>Vehicle Insurance :</div>
            <a
              :href="rider.user_info_im.ri_phorabo_img"
              target="_blank"
              style="text-decoration:none;"
            >
              <v-img
                v-if="rider.user_info_im.ri_phorabo_img"
                :src="rider.user_info_im.ri_phorabo_img"
                aspect-ratio="1"
                contain
                height="200"
              />
              <v-img
                v-else
                src="https://www.freeiconspng.com/uploads/no-image-icon-6.png"
                aspect-ratio="1"
                contain
                height="200"
              />
            </a>
          </v-flex>
          <v-flex lg3 md4 sm6 xs12 class="text-xs-center pt-2">
            <div>Book Bank : {{rider.user_info.ri_bookbank_name}}</div>
            <a
              :href="rider.user_info_im.ri_book_bank_img"
              target="_blank"
              style="text-decoration:none;"
            >
              <v-img
                v-if="rider.user_info_im.ri_book_bank_img"
                :src="rider.user_info_im.ri_book_bank_img"
                aspect-ratio="1"
                contain
                height="200"
              />
              <v-img
                v-else
                src="https://www.freeiconspng.com/uploads/no-image-icon-6.png"
                aspect-ratio="1"
                contain
                height="200"
              />
            </a>
          </v-flex>
          <div style="position:absolute;right:10px;bottom:10px;">
            <v-card color="secondary" class="pa-2">
              <p>Created At : {{ convertFormat(rider.users.created_at) }}</p>
              Update At : {{ convertFormat(rider.users.update_at) }}
            </v-card>
          </div>
        </v-layout>
      </div>
      <div></div>
    </v-card-text>
  </v-card>
</template>
<script>
export default {
  props: ["rider"],
  data: function() {
    return {};
  },
  methods: {
    convertFormat(date_time) {
      if (date_time != null) {
        return this.moment(date_time).format("MMMM Do YYYY, h:mm:ss a");
      } else {
        return null;
      }
    }
  },
  created() {}
};
</script>
<style scoped>
.min-height {
  min-height: 295px;
}
</style>


